function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata876"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref3 = /*#__PURE__*/React.createElement("defs", {
  id: "defs874"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path964-7",
  d: "m 79.890558,53.300057 c -5.023407,10e-7 -9.729887,-2.526806 -12.330077,-6.789062 -2.60019,-4.262256 -2.60019,-9.651807 0,-13.914063 2.600189,-4.262255 7.306669,-6.789062 12.330077,-6.789062 v 8.089844 c -2.30083,0 -4.363847,1.171379 -5.425779,2.912109 -1.061931,1.74073 -1.061932,3.747551 0,5.488281 1.061932,1.74073 3.124949,2.91211 5.425779,2.91211 z"
}), /*#__PURE__*/React.createElement("rect", {
  ry: 0.00000359872,
  y: 35.331306,
  x: 38.482357,
  height: 7.8125,
  width: 28.174341,
  id: "rect962"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer3"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1514",
  d: "m 21.052734,16.490234 a 1.50015,1.50015 0 1 0 0,3 h 7.847657 a 1.50015,1.50015 0 1 0 0,-3 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1514-3",
  d: "m 21.052734,23.955078 a 1.50015,1.50015 0 1 0 0,3 h 7.847657 a 1.50015,1.50015 0 1 0 0,-3 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1514-6",
  d: "m 21.052734,31.503906 a 1.50015,1.50015 0 1 0 0,3 h 7.847657 a 1.50015,1.50015 0 1 0 0,-3 z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "layer2"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 30.415725,58.762924 c 0,5.052439 -3.830102,9.148312 -8.554705,9.148312 -4.724605,0 -8.554705,-4.095873 -8.554705,-9.148312 0,-3.385593 1.7211,-6.339352 4.27735,-7.921441 l 0.17196,-10.285494 c 0.0422,-2.525838 1.915047,-4.574156 4.277349,-4.574156 2.362301,0 4.105398,1.689176 4.105398,4.215397 v 10.644253 c 2.556253,1.582089 4.277353,4.535848 4.277353,7.921441 z m 4.277352,-12.100501 c 2.661583,3.225208 4.277354,7.460732 4.277354,12.100501 0,10.105455 -7.659536,18.296623 -17.109411,18.296623 -0.03997,0 -0.0814,-1.44e-4 -0.121504,-3.06e-4 -9.397081,-0.06975 -17.0356214,-8.342253 -16.9876414,-18.391529 0.0219,-4.602458 1.63382,-8.802108 4.27709,-12.005158 V 17.595518 c 0,-7.578662 5.7451504,-13.7224681 12.8320554,-13.7224681 7.086905,0 12.832057,6.1438061 12.832057,13.7224681 z m -2.138676,12.100501 c 0,-4.9085 -2.589135,-7.460165 -4.277352,-9.505957 V 17.595518 c 0,-3.783257 -2.878258,-6.861234 -6.416029,-6.861234 -3.537775,0 -6.416025,3.077977 -6.416025,6.861234 v 31.661449 c -1.70186,2.062373 -4.25396,4.58845 -4.27722,9.445632 -0.0299,6.271741 4.75361,11.451972 10.616252,11.495428 l 0.07699,2.94e-4 c 5.89633,0 10.693381,-5.129915 10.693381,-11.435391 z",
  id: "path866"
}));

var SvgTempSensor = function SvgTempSensor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg870",
    role: "presentation",
    "aria-hidden": "true",
    viewBox: "0 0 80 80",
    focusable: "false",
    className: "MuiSvgIcon-root",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTempSensor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/temp-sensor.782c100c.svg";
export { ForwardRef as ReactComponent };